﻿import {useRoute} from "vue-router";
import {AthumiService} from "@/api/enterprise-gateway-api.proxy.ts";
import {computed} from "vue";
import {safeRouteParamToString} from "@/router/route-utils.ts";
import {getServiceTermsLink} from "@/app/shared/helpers/terms-and-conditions.ts";
import {defineStore} from "pinia";

export const formatService = (service: AthumiService): string => {
    switch (service) {
        case AthumiService.ELys:
            return 'eLys';
        case AthumiService.Klip:
            return 'KLIP';
        case AthumiService.Vip:
            return 'VIP';
    }

    return '';
}

export const useAthumiService = defineStore('athumi-service-store', () => {
    const route = useRoute();
    
    const parseServiceName = (serviceName: string): AthumiService => {
        const enumValues = Object.values(AthumiService) as string[];
        const matchingValue = enumValues.find(
            value => value.toLowerCase() === serviceName.toLowerCase()
        );
        if (!matchingValue) {
            throw new Error(`Unknown service name: ${serviceName}`);
        }
        return matchingValue as AthumiService;
    };

    const service = computed((): AthumiService =>
        parseServiceName(safeRouteParamToString(route.params.service)));

    const serviceTitle = computed((): string | undefined => {
        return formatService(service.value);        
    });
    
    const termsAndConditionsLink = computed((): string | undefined => getServiceTermsLink(service.value));

    return {
        service,
        serviceTitle,
        termsAndConditionsLink
    }; 
});
